import React from 'react';

export const DoorOpen = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            xmlns='http://www.w3.org/2000/svg'
            width='22'
            height='18'
            viewBox='0 0 22 18'
            fill='none'>
            <path
                d='M9 9H9.01M17 17V3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H7C6.46957 1 5.96086 1.21071 5.58579 1.58579C5.21071 1.96086 5 2.46957 5 3V17M1 17H21'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};
